import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _get from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import "./chunk-PXG64RU4.js"; // src/infiniteQueryObserver.ts

import { QueryObserver } from "./queryObserver.js";
import { hasNextPage, hasPreviousPage, infiniteQueryBehavior } from "./infiniteQueryBehavior.js";

var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
  function InfiniteQueryObserver(client, options) {
    _classCallCheck(this, InfiniteQueryObserver);

    return _callSuper(this, InfiniteQueryObserver, [client, options]);
  }

  _inherits(InfiniteQueryObserver, _QueryObserver);

  return _createClass(InfiniteQueryObserver, [{
    key: "bindMethods",
    value: function bindMethods() {
      _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "bindMethods", this).call(this);

      this.fetchNextPage = this.fetchNextPage.bind(this);
      this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "setOptions", this).call(this, _objectSpread(_objectSpread({}, options), {}, {
        behavior: infiniteQueryBehavior()
      }));
    }
  }, {
    key: "getOptimisticResult",
    value: function getOptimisticResult(options) {
      options.behavior = infiniteQueryBehavior();
      return _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "getOptimisticResult", this).call(this, options);
    }
  }, {
    key: "fetchNextPage",
    value: function fetchNextPage(options) {
      return this.fetch(_objectSpread(_objectSpread({}, options), {}, {
        meta: {
          fetchMore: {
            direction: "forward"
          }
        }
      }));
    }
  }, {
    key: "fetchPreviousPage",
    value: function fetchPreviousPage(options) {
      return this.fetch(_objectSpread(_objectSpread({}, options), {}, {
        meta: {
          fetchMore: {
            direction: "backward"
          }
        }
      }));
    }
  }, {
    key: "createResult",
    value: function createResult(query, options) {
      var _a, _b;

      var state = query.state;

      var parentResult = _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "createResult", this).call(this, query, options);

      var isFetching = parentResult.isFetching,
          isRefetching = parentResult.isRefetching,
          isError = parentResult.isError,
          isRefetchError = parentResult.isRefetchError;
      var fetchDirection = (_b = (_a = state.fetchMeta) == null ? void 0 : _a.fetchMore) == null ? void 0 : _b.direction;
      var isFetchNextPageError = isError && fetchDirection === "forward";
      var isFetchingNextPage = isFetching && fetchDirection === "forward";
      var isFetchPreviousPageError = isError && fetchDirection === "backward";
      var isFetchingPreviousPage = isFetching && fetchDirection === "backward";

      var result = _objectSpread(_objectSpread({}, parentResult), {}, {
        fetchNextPage: this.fetchNextPage,
        fetchPreviousPage: this.fetchPreviousPage,
        hasNextPage: hasNextPage(options, state.data),
        hasPreviousPage: hasPreviousPage(options, state.data),
        isFetchNextPageError: isFetchNextPageError,
        isFetchingNextPage: isFetchingNextPage,
        isFetchPreviousPageError: isFetchPreviousPageError,
        isFetchingPreviousPage: isFetchingPreviousPage,
        isRefetchError: isRefetchError && !isFetchNextPageError && !isFetchPreviousPageError,
        isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
      });

      return result;
    }
  }]);
}(QueryObserver);

export { InfiniteQueryObserver };